(() => {
  const tag = 'roulette-social-proof-story';
  if (!window.customElements || customElements.get(tag)) return;

  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        if (this.motion.matches) this.revealAll();
      };
      this.motion.addEventListener('change', this.onMotionChange);

      if (this.motion.matches || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });

      this.querySelectorAll('[data-social-reveal]').forEach((element) => {
        // Keep content visible when a page is restored at an existing scroll position.
        if (element.getBoundingClientRect().top < window.innerHeight) return;
        element.classList.add('is-pending');
        this.observer.observe(element);
      });
    }

    revealAll() {
      this.observer?.disconnect();
      this.querySelectorAll('.is-pending').forEach((element) => element.classList.remove('is-pending'));
    }

    disconnectedCallback() {
      this.revealAll();
      this.motion?.removeEventListener('change', this.onMotionChange);
    }
  });
})();
